var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_39875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0836 4.1731L10.0952 9.16154C9.53897 9.71636 8.78541 10.0279 7.99978 10.0279C7.21416 10.0279 6.4606 9.71636 5.90438 9.16154L0.915931 4.1731C0.907635 4.26673 0.888672 4.35147 0.888672 4.4445V11.5556C0.889613 12.3412 1.20208 13.0942 1.75754 13.6497C2.313 14.2052 3.0661 14.5176 3.85163 14.5186H12.1479C12.9335 14.5176 13.6866 14.2052 14.242 13.6497C14.7975 13.0942 15.11 12.3412 15.1109 11.5556V4.4445C15.1109 4.35147 15.0919 4.26673 15.0836 4.1731Z",
    fill: "#6442A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25778 8.32352L14.6705 2.91019C14.4083 2.47541 14.0385 2.11554 13.5967 1.86529C13.155 1.61503 12.6562 1.48283 12.1485 1.48145H3.85215C3.34443 1.48283 2.84563 1.61503 2.40387 1.86529C1.96211 2.11554 1.59229 2.47541 1.33008 2.91019L6.74282 8.32352C7.07679 8.65615 7.52894 8.84291 8.0003 8.84291C8.47166 8.84291 8.92381 8.65615 9.25778 8.32352Z",
    fill: "#6442A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_39875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 14.2222,
    fill: "white",
    transform: "translate(0.888672 0.888916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.6c2abce7a327310f1dcfd04c918ac59f.svg";
export { ForwardRef as ReactComponent };